var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLogin)?_c('navigation'):_c('navigation-landing'),_c('v-main',[_vm._t("default")],2),_c('footer-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }